import { render, staticRenderFns } from "./ConfirmationValuesContainer.vue?vue&type=template&id=5fdaa9da&scoped=true"
import script from "./ConfirmationValuesContainer.vue?vue&type=script&lang=js"
export * from "./ConfirmationValuesContainer.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationValuesContainer.vue?vue&type=style&index=0&id=5fdaa9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdaa9da",
  null
  
)

export default component.exports